// extracted by mini-css-extract-plugin
module.exports = {"footer-wrapper":"Footer_footer-wrapper__164LQ","copyright":"Footer_copyright__7FClQ","icon-contact-information":"Footer_icon-contact-information__3OyF4","ull":"Footer_ull__fdgd_"};